import React from 'react';
import { Box } from '@mui/material';
import {
  SectionTitle,
  HowItWorksContainer,
  StepCard,
  StepNumber,
  StepImageContainer,
  StepTitle,
  StepDescription
} from '../styles';
import step1Image from '../images/step1.png';
import step2Image from '../images/step2.png';
import step3Image from '../images/step3.png';

interface Step {
  number: number;
  image: string;
  title: string;
  description: string;
}

const steps: Step[] = [
  {
    number: 1,
    image: step1Image,
    title: 'Choose your Agentic Partner',
    description: 'Browse available partner integrations like PayPal',
  },
  {
    number: 2,
    image: step2Image,
    title: 'Request Activation',
    description: 'Contact Logicbroker to establish connection',
  },
  {
    number: 3,
    image: step3Image,
    title: 'Sell More With AI',
    description: 'Receive AI driven sales',
  },
];

const HowItWorks = () => {
  return (
    <Box>
      <SectionTitle>
        How Agentic Commerce Works
      </SectionTitle>
      <HowItWorksContainer>
        {steps.map((step) => (
          <StepCard key={step.number}>
            <StepNumber>{step.number}</StepNumber>
            <StepImageContainer>
              <img src={step.image} alt={`Step ${step.number}`} />
            </StepImageContainer>
            <StepTitle>
              {step.title}
            </StepTitle>
            <StepDescription>
              {step.description}
            </StepDescription>
          </StepCard>
        ))}
      </HowItWorksContainer>
    </Box>
  );
};

export default HowItWorks;